import { render, staticRenderFns } from "./BtnActualizarPreciosActuales.vue?vue&type=template&id=2ff991ad&"
import script from "./BtnActualizarPreciosActuales.vue?vue&type=script&lang=js&"
export * from "./BtnActualizarPreciosActuales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports